import { useGetAllSupplementData } from "@/lib/api/engageApi";
import { DropdownSearchCombobox } from "./DropdownSearchCombobox";

interface DropdownSupplementSearchProps {
  type: string;
  value?: string;
  placeholder?: string;
  onChange: (value: string) => void;
}

const DropdownSupplementSearch = ({
  type,
  value,
  placeholder,
  onChange,
}: DropdownSupplementSearchProps) => {
  const { data } = useGetAllSupplementData(
    { type, status: true },
    {
      request: {
        headers: {
          isPaginated: false,
        },
      },
    }
  );
  
  return (
    <DropdownSearchCombobox
      options={
        data?.data?.map((item) => ({
          label: item.name,
          value: item.id?.toString(),
        })) || []
      }
      value={value}
      placeholder={placeholder}
      onChange={(value) => onChange(value)}
    />
  );
};

export default DropdownSupplementSearch;